require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-pages-freight-forwarder.json") })
        }
      }, "path---en-pages-freight-forwarder");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-pages-freight-forwarder!./.cache/json/en-pages-freight-forwarder.json
// module id = 756
// module chunks = 231608221292675